export default {
  synonymSearchResults: [],
  synonymSearchResult: undefined,
};
